import { React, useEffect, useState } from "react";
import { Stepper } from "react-form-stepper";
import Button from '../../components/Button.jsx'
import {
  List,
  ListItem,
  ListItemIcon,
  TextField,
  Grid,
} from "@material-ui/core";
import ImageCrop from "../../library/imageCrop";
import '../../css/AgregarEmpleadoModal.css'
import { getCity, getDistrito } from "../../utils/peticionesApi";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { InputAdornment } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser, faPassport, faUserCircle, faCakeCandles, faEnvelope, faMobileScreen,
  faLocationArrow,
  faHashtag,
  faBuilding,
  faCity,
  faCalendarAlt,
  faUserShield
} from "@fortawesome/free-solid-svg-icons";

const AgregarEmpleadoModal = ({
  closeModal,
  formData,
  setFormData,
  handleChange,
  handleSubmit,
  error,
  currentPage,
}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [setUserProfilePic] = useState("");
  const [scaleValue, setScaleValue] = useState(1);
  const [editor, setEditor] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [distrito, setDistrito] = useState(null);
  const [ciudad, setCiudad] = useState(null);

  useEffect(() => {
    listarDistrito()
    listarCiudad()
  }, [])


  useEffect(() => {
    console.log("Updated formData:", formData);
  }, [formData]);

  const availableRoles = ["ROLE_ADMIN", "ROLE_USER", "ROLE_RRHH", "ROLE_SUPERVISOR"];
  const roleLabels = {
    "ROLE_ADMIN": "Administrador",
    "ROLE_USER": "Empleado",
    "ROLE_RRHH": "RRHH",
    "ROLE_SUPERVISOR": "Supervisor"
  };

  const validateStep = (step) => {
    const newErrors = {};

    if (step === 0) {
      if (!formData.person.name) newErrors.name = "El nombre es obligatorio";
      if (!formData.person.lastname) newErrors.lastname = "El apellido es obligatorio";

      if (!formData.email) {
        newErrors.email = "Email es obligatorio";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Formato de email inválido";
      }

      if (!formData.person.national_id) newErrors.national_id = "El DNI es obligatorio";
      if (!formData.person.date_of_birth) newErrors.date_of_birth = "La fecha de nacimiento es obligatoria";
      if (!formData.cell_phone) newErrors.cell_phone = "El celular es obligatorio";

    } else if (step === 1) {
      if (!formData.address.street) newErrors.street = "La calle es obligatoria";
      if (!formData.address.number) newErrors.number = "El número es obligatorio";
      if (!formData.city.id_district) newErrors.id_district = "El distrito es obligatorio";
      if (!formData.city.name) newErrors.nameCity = "La ciudad es obligatoria";
      if (!formData.city.zip_code) newErrors.zip_code = "El código postal es obligatorio";

    } else if (step === 2) {
      if (!formData.status.entry_date) {
        newErrors.entry_date = "La fecha de alta laboral es obligatoria";
      }

      if (!formData.user.roles || formData.user.roles === "") {
        newErrors.roles = "Debe seleccionar un rol";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const listarDistrito = async () => {
    try {
      const response = await getDistrito(currentPage)
      setDistrito(response.data.content);
    } catch (error) {
      console.log(error)
    }

  };


  const listarCiudad = async () => {
    try {
      const response = await getCity(currentPage)
      setCiudad(response.data.content);
    } catch (error) {
      console.log(error)
    }
  };

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const steps = [
    {
      label: "Datos personales",
    },
    {
      label: "Domicilio",
    },
    {
      label: "Usuario",
    },
  ];
  const roles = [
    { id: 1, name: "ROLE_ADMIN" },
    { id: 2, name: "ROLE_RRHH" },
    { id: 3, name: "ROLE_USER" },
    { id: 4, name: "ROLE_SUPERVISOR" },
    { id: 5, name: "ROLE_OPERADOR" },
  ];

  const setEditorRef = (editor) => setEditor(editor);

  const onCrop = () => {
    if (editor !== null) {
      const url = editor.getImageScaledToCanvas().toDataURL();
      setUserProfilePic(url);
    }
  };

  const onScaleChange = (scaleChangeEvent) => {
    const scaleValue = parseFloat(scaleChangeEvent.target.value);
    setScaleValue(scaleValue);
  };

  const profilePicChange = (fileChangeEvent) => {
    const file = fileChangeEvent.target.files[0];
    const { type } = file;
    if (
      !(
        type.endsWith("jpeg") ||
        type.endsWith("png") ||
        type.endsWith("jpg") ||
        type.endsWith("gif")
      )
    ) {
      // Puedes manejar el caso donde el tipo de archivo no es válido
    } else {
      setSelectedImage(file);
    }
  };

  const handleCheckboxChange = (event) => {
    const { checked } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      save_in_zkteco: checked,
    }));
  };

  return (
    <>
      <div className="container-modal-form-empleado">
        <Stepper
          steps={steps}
          activeStep={activeStep}
          styleConfig={{
            activeBgColor: "#8F3B8C",
            activeTextColor: "#fff",
            inactiveBgColor: "#fff",
            inactiveTextColor: "#2b7cff",
            completedBgColor: "#fff",
            completedTextColor: "#2b7cff",
            size: "1.4rem",
          }}
          onSelect={setActiveStep}
          className={"stepper"}
          stepClassName={"stepper__step"}
        />
        <div>
          {activeStep === 0 && (
            <div className="text-modal">
              <List>
                <Grid
                  container
                >
                  <Grid item xs={11} sm={11} md={6} >
                    <ListItem className="list-modal">
                      <ListItemIcon>
                        <i className="fa-solid fa-circle-user"></i>
                      </ListItemIcon>
                      <TextField
                        id="standard-basic"
                        placeholder="Nombre"
                        label="Nombre"
                        value={formData.person.name}
                        variant="standard"
                        name="person.name"
                        onChange={handleChange}
                        className="item-list-modal"
                        error={!!errors.name}
                        helperText={errors.name}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FontAwesomeIcon icon={faUser} className="icon-input-login" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </ListItem>

                    <ListItem className="list-modal">
                      <TextField
                        id="standard-basic"
                        placeholder="Apellido"
                        label="Apellido"
                        value={formData.person.lastname}
                        variant="standard"
                        name="person.lastname"
                        onChange={handleChange}
                        className="item-list-modal"
                        error={!!errors.lastname}
                        helperText={errors.lastname}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FontAwesomeIcon icon={faUserCircle} className="icon-input-login" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </ListItem>

                    <ListItem className="list-modal">
                      <TextField
                        id="standard-basic"
                        label="DNI"
                        placeholder="DNI"
                        value={formData.person.national_id}
                        variant="standard"
                        name="person.national_id"
                        onChange={(e) => {
                          const value = e.target.value;
                          // Solo permitir dígitos
                          if (/^\d*$/.test(value)) {
                            handleChange(e);
                          }
                        }}
                        onKeyDown={(e) => {
                          // Permitir solo teclas numéricas y control (como backspace, flechas, tab)
                          const validKeys = [
                            'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete',
                          ];
                          if (
                            !/^[0-9]$/.test(e.key) &&
                            !validKeys.includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className="item-list-modal"
                        error={!!errors.national_id}
                        helperText={errors.national_id}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FontAwesomeIcon icon={faPassport} className="icon-input-login" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </ListItem>

                  </Grid>
                  <Grid item xs={11} sm={11} md={6}>
                    <ListItem className="list-modal">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Fecha de nacimiento"
                          format="DD-MM-YYYY"
                          value={
                            formData.person.date_of_birth
                              ? dayjs(formData.person.date_of_birth, "DD-MM-YYYY")
                              : null
                          }
                          onChange={(newValue) => {
                            const formattedDate = dayjs(newValue).format("DD-MM-YYYY");
                            setFormData((prev) => ({
                              ...prev,
                              person: {
                                ...prev.person,
                                date_of_birth: formattedDate,
                              },
                            }));
                          }}
                          slotProps={{
                            textField: {
                              variant: "standard",
                              placeholder: "Fecha de nacimiento",
                              className: "item-list-modal",
                              error: !!errors.date_of_birth,
                              helperText: errors.date_of_birth,
                              InputProps: {
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FontAwesomeIcon
                                      icon={faCakeCandles}
                                      className="icon-input-login"
                                    />
                                  </InputAdornment>
                                ),
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </ListItem>

                    <ListItem className="list-modal">
                      <TextField
                        id="standard-basic"
                        placeholder="Ingrese su email"
                        label="Ingrese su email"
                        value={formData.email}
                        variant="standard"
                        name="email"
                        onChange={handleChange}
                        className="item-list-modal"
                        error={!!errors.email}
                        helperText={errors.email}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FontAwesomeIcon icon={faEnvelope} className="icon-input-login" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </ListItem>

                    <ListItem className="list-modal">
                      <TextField
                        id="standard-basic"
                        placeholder="Celular"
                        label="Celular"
                        value={formData.cell_phone}
                        variant="standard"
                        name="cell_phone"
                        onChange={handleChange}
                        className="item-list-modal"
                        error={!!errors.cell_phone}
                        helperText={errors.cell_phone}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FontAwesomeIcon icon={faMobileScreen} className="icon-input-login" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </ListItem>
                  </Grid>

                </Grid>
              </List>
            </div>
          )}
        </div>
        <div>
          {activeStep === 1 && (
            <div className="text-modal">
              <Grid container spacing={2}>
                {/* Columna izquierda */}
                <Grid item xs={12} md={6}>
                  <ListItem className="list-modal">
                    <TextField
                      id="standard-basic"
                      placeholder="Calle"
                      label="Calle"
                      variant="standard"
                      name="address.street"
                      value={formData.address.street}
                      onChange={handleChange}
                      className="item-list-modal"
                      error={!!errors.street}
                      helperText={errors.street}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FontAwesomeIcon icon={faLocationArrow} className="icon-input-login" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </ListItem>

                  <ListItem className="list-modal">
                    <TextField
                      id="standard-basic"
                      placeholder="Número"
                      label="Número"
                      variant="standard"
                      name="address.number"
                      value={formData.address.number}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          handleChange(e);
                        }
                      }}
                      onKeyDown={(e) => {
                        const validKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
                        if (!/^[0-9]$/.test(e.key) && !validKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      className="item-list-modal"
                      error={!!errors.number}
                      helperText={errors.number}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FontAwesomeIcon icon={faHashtag} className="icon-input-login" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </ListItem>

                  <ListItem className="list-modal">
                    <TextField
                      id="standard-basic"
                      placeholder="Piso"
                      label="Piso"
                      variant="standard"
                      name="address.floor"
                      value={formData.address.floor}
                      onChange={handleChange}
                      className="item-list-modal"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FontAwesomeIcon icon={faBuilding} className="icon-input-login" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </ListItem>

                  <ListItem className="list-modal">
                    <TextField
                      id="standard-basic"
                      placeholder="Departamento"
                      label="Departamento"
                      variant="standard"
                      name="address.apartament"
                      value={formData.address.apartament}
                      onChange={handleChange}
                      className="item-list-modal"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FontAwesomeIcon icon={faHashtag} className="icon-input-login" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </ListItem>
                </Grid>

                {/* Columna derecha */}
                <Grid item xs={12} md={6}>
                  <ListItem className="list-modal">
                    <TextField
                      select
                      label="Distrito"
                      variant="standard"
                      name="city.id_district"
                      value={formData.city.id_district}
                      onChange={handleChange}
                      className="item-list-modal"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FontAwesomeIcon icon={faCity} className="icon-input-login" />
                          </InputAdornment>
                        ),
                      }}
                      SelectProps={{
                        native: true,
                      }}
                    >
                      <option value="">Selecciona un distrito</option>
                      {distrito.map((distrit) => (
                        <option key={distrit.id} value={distrit.id}>
                          {distrit.name}
                        </option>
                      ))}
                    </TextField>
                    {errors.id_district && (
                      <span className="error-text">{errors.id_district}</span>
                    )}
                  </ListItem>

                  {ciudad && (
                    <ListItem className="list-modal">
                      <TextField
                        select
                        label="Ciudad"
                        variant="standard"
                        name="city.name"
                        value={formData.city.name}
                        onChange={handleChange}
                        className="item-list-modal"
                        error={!!errors.nameCity}
                        helperText={errors.nameCity}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FontAwesomeIcon icon={faCity} className="icon-input-login" />
                            </InputAdornment>
                          ),
                        }}
                        SelectProps={{
                          native: true,
                        }}
                      >
                        <option value="">Selecciona una ciudad</option>
                        {ciudad.map((city) => (
                          <option key={city.id} value={city.name}>
                            {city.name}
                          </option>
                        ))}
                      </TextField>
                    </ListItem>
                  )}

                  <ListItem className="list-modal">
                    <TextField
                      id="standard-basic"
                      placeholder="Código Postal"
                      label="Código Postal"
                      value={formData.city.zip_code}
                      variant="standard"
                      name="city.zip_code"
                      onChange={handleChange}
                      className="item-list-modal"
                      error={!!errors.zip_code}
                      helperText={errors.zip_code}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FontAwesomeIcon icon={faHashtag} className="icon-input-login" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </ListItem>
                </Grid>
              </Grid>
            </div>
          )}
        </div>
        <div>
        </div>
        <div>
          {activeStep === 2 && (
            <div className="text-modal">
              <Grid container spacing={3}>
                {/* Columna izquierda - Foto */}
                <Grid item xs={12} md={6}>
                  <center>
                    <div className="mb-3">
                      <h4 htmlFor="formFile" className="form-label">
                        Foto de perfil
                      </h4>
                      <input
                        className="form-control"
                        type="file"
                        accept="image/png, image/jpeg"
                        name="profilePicBtn"
                        id="formFile"
                        onChange={profilePicChange}
                      />
                    </div>
                    <ImageCrop
                      imageSrc={selectedImage}
                      setEditorRef={setEditorRef}
                      onCrop={onCrop}
                      scaleValue={scaleValue}
                      onScaleChange={onScaleChange}
                    />
                  </center>
                </Grid>

                {/* Columna derecha - Fecha y Rol */}
                <Grid item xs={12} md={6}>

                  <ListItem className="list-modal">
                    <TextField
                      placeholder="Número de legajo"
                      label="Legajo"
                      variant="standard"
                      name="employee_number"
                      value={formData.employee_number?.toString().trim() || ""}
                      onChange={handleChange}
                      className="item-list-modal"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FontAwesomeIcon icon={faHashtag} className="icon-input-login" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </ListItem>

                  <ListItem className="list-modal">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Fecha de Alta laboral"
                        value={formData.status.entry_date ? dayjs(formData.status.entry_date, 'DD-MM-YYYY') : null}
                        onChange={(newValue) => {
                          const formattedDate = dayjs(newValue).format('DD-MM-YYYY');
                          setFormData((prev) => ({
                            ...prev,
                            status: {
                              ...prev.status,
                              entry_date: formattedDate,
                            },
                          }));
                        }}
                        format="DD-MM-YYYY"
                        slotProps={{
                          textField: {
                            variant: 'standard',
                            placeholder: 'Fecha de Alta laboral',
                            className: 'item-list-modal',
                            error: !!errors.entry_date,
                            helperText: errors.entry_date,
                            InputProps: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FontAwesomeIcon icon={faCalendarAlt} className="icon-input-login" />
                                </InputAdornment>
                              ),
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </ListItem>

                  <ListItem className="list-modal">
                    <TextField
                      select
                      label="Rol de usuario"
                      variant="standard"
                      name="user.roles"
                      value={formData.user.roles || ""}
                      onChange={handleChange}
                      className="item-list-modal"
                      error={!!errors.roles}
                      helperText={errors.roles}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FontAwesomeIcon icon={faUserShield} className="icon-input-login" />
                          </InputAdornment>
                        ),
                      }}
                      SelectProps={{
                        native: true,
                      }}
                    >
                      <option value="" disabled>
                        Seleccione un rol
                      </option>
                      {availableRoles.map((role) => (
                        <option key={role} value={role}>
                          {roleLabels[role]}
                        </option>
                      ))}
                    </TextField>
                  </ListItem>
                </Grid>
              </Grid>
            </div>
          )}
        </div>

        <div className="contenedor-buttons-modal">
          {activeStep === 0 && (
            <Button
              msj='Cancelar'
              tipe="sinbg"
              onClick={closeModal}
            />

          )}
          {activeStep > 0 && (
            <Button
              tipe="sinbg"
              msj='Anterior'
              onClick={handleBack}
            />

          )}
          {activeStep < steps.length - 1 && (
            <Button
              msj='Siguiente'
              onClick={handleNext}
            />

          )}
          {activeStep === steps.length - 1 && (
            <Button
              msj='Guardar empleado'
              onClick={() => {
                if (validateStep(activeStep)) {
                  handleSubmit(selectedImage);
                }
              }}
            />
          )}
        </div>
      </div>
      {error !== null && (
        <center>
          <p style={{ padding: "10px", color: "red" }}>{error}</p>
        </center>
      )}
    </>
  );
};

export default AgregarEmpleadoModal;